import { clsx } from 'clsx'
import { useLayoutVariant } from '../../hooks/useLayoutVariant'

export default function EmptyState({
  icon: Icon,
  title,
  description,
  message,
  action,
  className = ''
}) {
  const { isAdminAppUI } = useLayoutVariant()
  const text = description || message

  return (
    <div className={clsx(
      'text-center py-12 px-4',
      className
    )}>
      {Icon && (
        <Icon className={clsx(
          'mx-auto h-12 w-12 mb-4',
          isAdminAppUI ? 'text-[#3d5166]' : 'text-gray-400 dark:text-gray-500'
        )} />
      )}
      <h3 className={clsx(
        'text-sm font-medium mb-2',
        isAdminAppUI ? 'text-[#e8edf5]' : 'text-gray-900 dark:text-white'
      )}>
        {title}
      </h3>
      {text && (
        <p className={clsx(
          'text-sm mb-6 max-w-sm mx-auto',
          isAdminAppUI ? 'text-[#7a8fa6]' : 'text-gray-500 dark:text-gray-400'
        )}>
          {text}
        </p>
      )}
      {action && (
        <div className="flex justify-center">
          {action}
        </div>
      )}
    </div>
  )
}

